var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaboolaIconSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.995667,
    width: 38,
    height: 38,
    rx: 8,
    fill: "#0072B9",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7904 22.2012C11.4707 22.182 9.98519 19.977 10.0001 17.5258C10.0145 15.0741 11.5245 12.9045 14.8441 12.9245C18.1638 12.9428 19.6493 15.1303 19.6347 17.582C19.62 20.0328 18.11 22.2203 14.7904 22.2012V22.2012ZM14.8303 15.3754C13.5531 15.3677 13.3756 16.6096 13.37 17.5453C13.365 18.4814 13.5276 19.7425 14.8042 19.7504C16.0806 19.7572 16.2588 18.4992 16.2644 17.562C16.2699 16.6257 16.107 15.3823 14.8303 15.3754",
    fill: "#1470BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1549 22.2015C19.836 22.1816 18.3507 19.9766 18.3653 17.5254C18.379 15.0745 19.8897 12.9041 23.2088 12.9241C26.5282 12.9432 28.0138 15.1306 28 17.5816C27.9853 20.0333 26.4744 22.2202 23.1549 22.2015V22.2015ZM23.1948 15.3749C21.9183 15.3672 21.7409 16.6093 21.7356 17.5456C21.7294 18.4818 21.8923 19.7422 23.1695 19.7499C24.4451 19.7576 24.6236 18.4988 24.6289 17.5625C24.6343 16.626 24.4712 15.3819 23.1948 15.3749",
    fill: "#1470BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2639 22.2017C13.657 23.2708 16.1404 23.7455 18.8462 23.761C21.6888 23.7777 23.8443 23.2409 26.5732 22.2017L26.5573 25.1464C24.1149 26.3576 21.4663 27.0106 18.8269 26.9954C15.9507 26.9784 13.8776 26.3877 11.2461 25.1464L11.2639 22.2017",
    fill: "#1470BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(10 10.9957)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaboolaIconSmall);
export default __webpack_public_path__ + "static/media/TaboolaIcon_small.b9a00e1b.svg";
export { ForwardRef as ReactComponent };